export default __webpack_public_path__ + "static/isProcessing-9cec8f05914395c13dcec53a63077036.svg";